import { useState, useEffect, useCallback } from 'react';
import { useApi } from './useApi';

// Hook pour récupérer les zones disponibles
export const useZones = () => {
  const { apiCall } = useApi();
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchZones = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      // Essayer l'API mobile zones
      let data;
      try {
        data = await apiCall('/mobile/zones');
      } catch {
        // Fallback sur une liste de zones par défaut (à remplacer par une vraie API)
        data = await apiCall('/zones').catch(() => []);
      }

      console.log('✅ Zones récupérées:', data);

      const zonesList = Array.isArray(data) ? data : (data.zones || []);
      setZones(zonesList);

    } catch (err) {
      console.error('❌ Erreur récupération zones:', err);
      setError(err.message);
      // Fallback sur des zones par défaut du Bénin
      setZones([
        { id: '1', name: 'Cotonou', is_active: true },
        { id: '2', name: 'Porto-Novo', is_active: true },
        { id: '3', name: 'Parakou', is_active: true },
        { id: '4', name: 'Abomey-Calavi', is_active: true },
        { id: '5', name: 'Djougou', is_active: true },
        { id: '6', name: 'Bohicon', is_active: true },
        { id: '7', name: 'Natitingou', is_active: true },
        { id: '8', name: 'Kandi', is_active: true }
      ]);
    } finally {
      setLoading(false);
    }
  }, [apiCall]);

  useEffect(() => {
    fetchZones();
  }, [fetchZones]);

  return {
    zones,
    loading,
    error,
    refetch: fetchZones
  };
};

export default useZones;
